import store from '@/store'
import { tkParse } from '@moke/vue-tk'
export default async () => {
  // 获得今年年份保存到仓库
  let nowTime = await tkParse.getData(`https://api.mokekeji.com/time`)
  let date = new Date(nowTime)
  store.commit('setYear', date.getFullYear())
  // 自动登录判断
  if (!store.state.sessionToken) return
  tkParse.setSessionToken(store.state.sessionToken)
  let user = await tkParse.getData('/users/me').catch(e => {
    tkParse.setSessionToken(null)
    store.commit('setSessionToken', null)
  })
  // 判断用户身份
  // if (!user || !user.adminRole) {
  //   tkParse.setSessionToken(null)
  //   store.commit('setSessionToken', null)
  //   return
  // }
  // 不判断用户身份
  if (!user) {
    tkParse.setSessionToken(null)
    store.commit('setSessionToken', null)
    return
  }
  store.commit('setUser', user)
}
